<template>
    <div>
        <b-row class="mt-3">
            <b-col>
                <span>BM</span>
                <div class="font-weight-bold">{{ boletimMedicao.numero }}</div>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col>
                <span>CONTRATO</span>
                <div class="font-weight-bold">{{ this.contrato.codContrato }}</div>
            </b-col>
            <b-col>
                <span>COMPETÊNCIA</span>
                <div class="font-weight-bold">{{ this.$moment(boletimMedicao.competencia).format('YYYY/MM')  }}</div>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col>
                <span>FORNECEDOR</span>
                <div class="font-weight-bold">{{ fornecedor }}</div>
            </b-col>
            <b-col>
                <span>PROCESSO</span>
                <div class="font-weight-bold">{{ boletimMedicao.processo }}</div>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col>
                <span>CÓDIGO DA REQUISIÇÃO</span>
                <div class="font-weight-bold">{{ this.boletimMedicao.requisicao ? this.boletimMedicao.requisicao.idRequisicao : '' }}</div>
            </b-col>
            <b-col>
                <span>NECESSÁRIO ENVIO</span>
                <div class="font-weight-bold">
                    <b-badge :variant="classeCorRequerEnvio">
                        <span class="h6 text-uppercase ml-1 mr-1">
                            {{ requerEnvio }}
                        </span>
                    </b-badge>
                </div>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col>
                <span>DATA REQUISIÇÃO</span>
                <div class="font-weight-bold">{{ this.boletimMedicao.requisicao ? this.boletimMedicao.requisicao.dataRequisicao : '' | toDate }}</div>
            </b-col>
            <b-col>
                <span>DATA NECESSIDADE</span>
                <div class="font-weight-bold">{{ boletimMedicao.dataNecessidade | toDate }}</div>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col>
                <span>OBJETO</span>
                <div class="font-weight-bold">{{ this.contrato.objeto }}</div>
            </b-col>
            <b-col>
                <span>TEXTO COMPLEMENTAR</span>
                <div class="font-weight-bold">{{ boletimMedicao.textoComplementar }}</div>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col>
                <span>VALOR</span>
                <div class="font-weight-bold">{{ boletimMedicao.total | currency }}</div>
            </b-col>
            <b-col>
                <span>SOLICITANTE</span>
                <div class="font-weight-bold">{{ boletimMedicao.solicitante }}</div>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col>
                <span>SITUAÇÃO</span>
                <div class="font-weight-bold">
                    <b-badge :variant="obterClasseCorStatusBoletimMedicao(boletimMedicao.status)">
                        <span class="h6 text-uppercase ml-1 mr-1">
                            {{ obterDescricaoStatusBoletimMedicao(boletimMedicao.status) }}
                        </span>
                    </b-badge>
                </div>
            </b-col>
            <b-col>
                <span>DATA INÍCIO DA MEDIÇÃO</span>
                <div class="font-weight-bold">{{ boletimMedicao.dataInicio | toDate }}</div>

                <div class="mt-3">
                    <span>DATA FIM DA MEDIÇÃO</span>
                    <div class="font-weight-bold">{{ boletimMedicao.dataFim | toDate }}</div>
                </div>
            </b-col>
        </b-row>
        
    </div>
</template>

<script>

import { 
    obterDescricaoStatusBoletimMedicao,
    obterClasseCorStatusBoletimMedicao,
} from '../../BoletimMedicao.js';

export default {
    props: {
        contrato: {
            type: Object,
            default: null
        },

        boletimMedicao: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            
        }
    },

    computed: {
        requerEnvio() {
            return this.boletimMedicao.naoRequerEnvio ? 'Não' : 'Sim';
        },

        classeCorRequerEnvio() {
            return this.boletimMedicao.naoRequerEnvio ? 'secondary' : 'success';
        },

        fornecedor() {
            return this.contrato.fornecedor ? (`${this.contrato.fornecedor.cnpj} - ${this.contrato.fornecedor.nome}`) : '';
        }
    },

    methods: {
        obterDescricaoStatusBoletimMedicao,
        obterClasseCorStatusBoletimMedicao,
    },

}
</script>